<template>
    <div class="body">
        <Affix v-if="introduction">
            <div style="background:#fff;border-bottom: 1px solid #e9eaec;">
                <img :src="introduction.goodsdetail.iconurl" alt="test" class="gameImg">
                <div style="width: 70%;display: inline-block;vertical-align: top;">
                    <p style="padding-top: 16px">{{introduction.goodsdetail.goodsname}}</p>
                    <Rate v-model="introduction.gamesMap[gameType].level" :disabled="true"
                          v-if="introduction.gamesMap[gameType]"
                          style="background:#fff;"/>
                    <Rate v-model="zero" :disabled="true"
                          v-if="!introduction.gamesMap[gameType]"
                          style="background:#fff;"/>
                    <p style="display: inline-block;vertical-align: sub;" v-if="introduction.gamesMap[gameType]">
                        {{introduction.gamesMap[gameType].level}}{{$t('app_info_74')}}
                        <span>{{introduction.gamesMap[gameType].count}}</span>{{$t ('app_info_75')}}
                    </p>
                    <p style="display: inline-block;vertical-align: sub;" v-else>
                        0{{$t ('app_info_75')}}
                    </p>
                </div>
            </div>
            <Menu mode="horizontal" active-name="0" @on-select="selectTab">
                <MenuItem name="0">
                    {{$t('app_info_3')}}
                </MenuItem>
                <MenuItem name="1">
                    {{$t('app_info_4')}}
                </MenuItem>
            </Menu>
        </Affix>
        <div v-show="tabval == 0" >
            <Spin fix v-if="spinShow">
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div v-for="(imgitem,Iindex) in introduction.imgvideos" :key="Iindex"
                         class="swiper-slide"><img :src="imgitem.url" alt="description"
                                                   style="width: 100%;max-height: 180px;"></div>
                </div>
            </div>
            <Card style="margin:10px 0 " v-if="introduction">
                <p slot="title">{{$t ('app_info_36')}}</p>   <!--游戏简介-->
                <p style="word-wrap: break-word;">{{introduction.goodsdetail.description}}</p>
                <!--<p>{{ ("source") }}</p>-->
            </Card>
            <Card style="margin:10px 0 " v-if="introduction">
                <p slot="title">{{$t ('app_info_37')}}</p> <!--信息-->
                <p v-if="introduction.gamesMap[gameType]">{{$t ('version')}}: {{introduction.gamesMap[gameType].gameversion}}</p>   <!--版本-->
                <p v-if="introduction.gamesMap[gameType]">{{$t ('size')}}: {{introduction.gamesMap[gameType].size}} M</p> <!--大小-->
                <p v-if="language === 'zh_CN'">{{$t ('price')}}: {{introduction.goodsdetail.showprice}}
                    {{introduction.goodsdetail.currencySymbol}}
                    <!--中文价格-->
                    </p>
                <p v-else>{{$t ('price')}}: {{introduction.goodsdetail.currencySymbol}}
                    {{introduction.goodsdetail.showprice}}
                    <!--价格-->
                    </p>
                <p>{{$t ('language')}}: {{introduction.goodslanguage}}</p><!--语言-->
            </Card>
        </div>
        <div v-show="tabval == 1">
            <Modal
                class="indexModal"
                :mask-closable="false"
                v-model="modal1"
                :title="$t('app_info_5')"><!--撰写评论-->
                <Form ref="comment" :model="comment" :rules="ruleValidate">
                    <Spin fix v-if="commentsSpinShow">
                        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                        <div>{{$t('pleasewait')}}</div>
                    </Spin>
                    <div style="text-align: center">
                        <Rate v-model="comment.starValue" style="font-size: 30px;"></Rate>
                        <p style="color:#657180">{{$t('app_info_76')}}</p>
                    </div>
                    <h5 style="padding: 10px 0">{{$t('app_info_153')}}</h5>
                    <FormItem prop="title">
                        <Input v-model="comment.title" :maxlength='20' :placeholder="$t('app_info_153')"></Input>
                    </FormItem>
                    <h5 style="padding: 10px 0">{{$t('app_info_4')}}</h5>
                    <FormItem prop="comments">
                        <Input v-model="comment.comments" :maxlength='200' :rows="4" type="textarea"
                               :placeholder="$t('app_info_5')"></Input>
                    </FormItem>
                </Form>
                <div slot="footer">
                    <Button type="primary" @click="submitComment('comment')">{{$t ('send')}}</Button>
                </div>
            </Modal>
            <Modal v-model="modal2" width="360">
                <p style="color:#f60;">
                    <Icon type="information-circled"></Icon>
                    {{$t ('app_info_8')}}<!--您尚未登录，请先登录-->
                </p>
                <div slot="footer">
                    <a href="noloweb://android.login/?id=hello&name=cg">{{$t ('app_info_14')}}</a>   <!--登录/注册-->
                </div>
            </Modal>
            <Modal v-model="modal3" width="100%">
                <p slot="header" >
                </p>
                <img :src="modalUrl" alt="" style="width: 100%;">
                <div slot="footer" style="display: none">
                
                </div>
            </Modal>
            <Card class="rateCard" style="margin:10px 0" v-if="starData">
                <!--评分-->
                <p slot="title" >{{$t ('app_info_7')}} <span style="float: right">{{starData.count}}{{$t
                        ('app_info_75')}}</span></p>
                <p>
                    <Rate v-model="staticStar.val5" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="allstarRate(starData.fivestar)" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
                <p>
                    <Rate v-model="staticStar.val4" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="allstarRate(starData.fourstar)" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
                <p>
                    <Rate v-model="staticStar.val3" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="allstarRate(starData.threestar)" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
                <p>
                    <Rate v-model="staticStar.val2" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="allstarRate(starData.twostar)" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
                <p>
                    <Rate v-model="staticStar.val1" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="allstarRate(starData.onestar)" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
            </Card>
            <Card class="rateCard" style="margin:10px 0" v-else>
                <p slot="title" >{{$t ('app_info_7')}} <span style="float: right">0{{$t
                        ('app_info_75')}}</span></p>
                <p>
                    <Rate v-model="staticStar.val5" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="zero" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p> <p>
                    <Rate v-model="staticStar.val4" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="zero" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p> <p>
                    <Rate v-model="staticStar.val3" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="zero" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p> <p>
                    <Rate v-model="staticStar.val2" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="zero" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p> <p>
                    <Rate v-model="staticStar.val1" class="" :disabled="true" style="max-width: 40%"/>
                    <Progress :percent="zero" hide-info style="max-width: 59%"
                              :stroke-width="5"/>
                </p>
            </Card>
            <!--userid: {{userid}}, <br>bought: {{bought}}-->
            <Card style="margin:10px 0 " class="card_no_body">
                <p slot="title">{{$t('app_info_4')}}
                    <a href="javascript:;" style="float: right" :disabled="userid !== undefined && bought !== 'true'"
                       @click="insertComment()">{{$t
                        ('app_info_5')
                        }} </a></p>
                <p v-if="queryCommentPageList == ''">{{$t('no_comment_yet')}}</p>
                <template v-for="(commentList,index) in queryCommentPageList" v-else>
                    <div style="position: relative;margin-bottom: 20px">
                        <p style="margin-bottom: 5px;"><strong>{{commentList.title}}</strong></p>
                        <Row type="flex" style="margin-bottom: 10px;color: #A5A5A5;">
                            <Col span="12">
                                <Rate v-model="commentList.level" style="font-size: 12px;"></Rate>
                                <span v-if="commentList.userinfo">{{commentList.userinfo.nickname}}</span>
                            </Col>
                            <Col span="12" style="text-align: right">{{momentTranslate(commentList.createdate)}}
                            </Col>
                        </Row>
                        <template v-if="(commentList.comments).length > 110">
                            <p style="color: #757575;overflow: hidden" :class="{
                                height80: commentList.collapse == 0 }">
                                {{commentList.comments}}
                            </p>
                            <div class="moreComment"
                                 v-if="commentList.collapse == 0" @click="moreComment(index)"><span
                                style="">{{$t ('more')}}</span></div>
                        </template>
                        <template v-else>
                            <p style="color: #757575;">
                                {{commentList.comments}}
                            </p>
                        </template>
                    </div>
                    <div style="border-bottom: 1px solid #d9d9d9;margin-bottom: 20px"></div>
                </template>
            </Card>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import axios from 'axios';
    import moment from 'moment';
    import Swiper from 'swiper';
    export default {
        components: {},
        data() {
            var verificationTitle = (rule, value, callback) => {
                setTimeout(() => {
                    if (this.comment.title === '') {
                        return callback(new Error(this.$t('can_not_be_empty')))
                    } else {
                        callback()
                    }
                }, 100)
            }
            var verificationComment = (rule, value, callback) => {
                setTimeout(() => {
                    if (this.comment.comments === '') {
                        return callback(new Error(this.$t('can_not_be_empty')))
                    } else {
                        callback()
                    }
                }, 100)
            }
            return {
                zero:0,
                currency: '',
                language: '',
                userid: undefined,
                goodsid: '',
                gameid: '',
                tabval: 0,
                staticStar: {
                    val1: 1,
                    val2: 2,
                    val3: 3,
                    val4: 4,
                    val5: 5
                },
                modal1: false,
                modal2: false,
                modal3: false,
                spinShow: true,
                commentsSpinShow: false,  //提交等待
                introduction: '',        //详情
                comment: {
                    starValue: 5,
                    title: '',
                    comments: ''
                },
                starData: '',
                gameType: '2',             //cardboard or gear
                queryCommentPageList: '', //评论列表
                bought: '', // 是否已购买
                ruleValidate: {     //表单验证rule
                    // starValue: [
                    //     {required: true, message: '不能打架', trigger: 'blur'}
                    // ],
                    // title: [
                    //     {required: true, message: `${this.$t('can_not_be_empty')}`, trigger: 'blur'},
                    // ],
                    title: [
                        {required: true, validator: verificationTitle,  trigger: 'blur'},
                    ],
                    comments: [
                        {required: true, validator: verificationComment, trigger: 'blur'}
                    ]
                },
                modalUrl:''
            }
        }, created: function () {
            // 挂载开始之前被调用 render 函数首次被调用 $route.query获取url参数
            // 只有gear的 goodsid = '3' gameid = '16'
            
            this.goodsid = this.$route.query.goodsid;
            this.userid = this.$route.query.userid;
            this.gameid = this.$route.query.gameid;
            this.bought = this.$route.query.bought;
            this.currency = this.$route.query.currency;
            this.language = this.$route.query.language;
            // this.bought = 'true'
            // this.goodsid = '3';
            // this.userid = 'bfc2be2ddb024282b53aa588d5000499';
            // this.gameid = '16';
            // this.currency = 'cny';
            // this.language = 'zh_CN';
        },
        mounted() {
            location.href = 'noloweb://android.loadingsuccess/'
            let $this = this;
            if(!this.currency && !this.language){
                axios.post("https://appservices.nolovr.com/nolohome/country/queryCountryInfoforWeb", {}).then(response => {
                    if (response.data.responseCode == '0000') {
                        this.currency = response.data.country.currency;
                        this.language = response.data.country.language;
                        $this.$i18n.locale = this.language;
                    }
                    this.getData()
                }).catch(error => {
                    this.spinShow = false;
                    alert('error')
                });
            }else {
                $this.$i18n.locale = this.language;
                this.getData()
            }
        },
        methods: {
            getData() {
                let $this = this;
                axios.post("https://appservices.nolovr.com/nolohome/goods/queryGoodsDetailforWeb", {
                    language: $this.language, currency: $this.currency, goodsid: $this.goodsid
                }).then(response => {
                    if (response.data.responseCode == '0000') {
                        this.spinShow = false;
                        this.introduction = response.data.goodsInfo;
                        this.starData = this.introduction.gamesMap[this.gameType];
                    } else if (response.data.responseCode == '2222') {
                        this.$Message.error('Parameter error');
                    } else {
                        this.$Message.error('Game details parameter error');
                    }
                }).catch(error => {
                    this.spinShow = false;
                    alert(error)
                });
                axios.post("https://appservices.nolovr.com/nolohome/comment/queryCommentPageListforWeb", {
                    userid: $this.userid, language: $this.language, currency:
                    $this.currency, goodsid: $this.goodsid, pageNum: '1', gameid: $this.gameid
                }).then(response => {
                    if (response.data.responseCode == '0000') {
                        this.queryCommentPageList = response.data['goodscommentInfoList'];
                        for (const commentList in this.queryCommentPageList) {
                            Vue.set(this.queryCommentPageList[commentList], 'collapse', 0)
                        }
                        new Swiper('.swiper-container',{
                            observer:true, //修改swiper自己或子元素时，自动初始化swiper
                            observeParents:true,//修改swiper的父元素时，自动初始化swiper
                            lazyLoading : true,//懒加载开启
                            // autoHeight: true //高度随内容变化
                        })
                    }
                }).catch(error => {
                    this.spinShow = false;
                    alert(error)
                });
            },
            submitComment(name) {       //插入商品评论
                let $this = this;
                this.commentsSpinShow = true;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        axios.post("https://appservices.nolovr.com/nolohome/comment/insertCommentforWeb", {
                            userid: $this.userid,
                            goodsid: $this.goodsid,
                            gameid: $this.gameid,
                            language: $this.language,
                            level: this.comment.starValue + '',
                            title: this.comment.title,
                            comments: this.comment.comments
                        }).then(response => {
                            this.commentsSpinShow = false;
                            if (response.data.responseCode == '0000') {
                                this.$Message.info(this.$i18n.t('app_info_102'));   //提交成功，需要审核通过才能看到
                                this.modal1 = false;
                                this.comment.starValue = 5
                                this.comment.title = ''
                                this.comment.comments = ''
                            } else if(response.data.responseCode == '4450') {
                                this.$Message.error(this.$i18n.t('sensitive_words'));
                            } else if(response.data.responseCode == '9999') {
                                this.$Message.error(this.$i18n.t('enter_correct_content'));
                            } else {
                                // this.$Message.error('Fail! 错误码: '+ response.data.responseCode);
                                this.$Message.error('Fail!');
                            }
                        }).catch(error => {
                            this.commentsSpinShow = false;
                            alert(this.$i18n.t('app_info_102'));
                        });
                    } else {
                        this.commentsSpinShow = false;
                        this.$Message.error(this.$i18n.t('pleasecomplete'));
                    }
                })
            },
            insertComment() {
                if (this.userid !== undefined) {
                    this.modal1 = true;
                } else {
                    this.modal2 = true;
                }
            },
            userLogin() {

            },
            allstarRate(val) {      //计算全部星级比例方法
                let _allval = this.starData.onestar + this.starData.twostar + this.starData.threestar +
                    this.starData.fourstar + this.starData.fivestar;
                if (val == 0) {
                    return 0
                } else {
                    let _rate = Math.round(val / _allval * 100);
                    return _rate;
                }
            },
            moreComment(val) {
                this.queryCommentPageList[val].collapse = 1;
            },
            momentTranslate(date) {
                return moment(date).format('MM-DD');
            },
            selectTab(name) {
                this.tabval = name;
            },
            imgModal(url) {
                this.modalUrl = url
                this.modal3 = true;
            }
        }
    }
</script>

<style>
    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite;
    }
    
    @keyframes ani-demo-spin {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    
    body {
        background-color: #F5F5F5 !important;
    }
    
    .body {
        background: #F5F5F5;
    }
    
    .indexCarousel {
        margin-top: 20px;
    }
    
    .indexCarousel .ivu-carousel-dots-inside {
        bottom: 20px;
    }
    
    .gameImg {
        border-radius: 15px;
        max-width: 20%;
        padding: .5rem;
    }
    
    .ivu-tabs-bar {
        background: #fff;
    }
    
    .ivu-affix, .ivu-back-top {
        z-index: 20 !important;
    }
    
    .rateCard .ivu-rate {
        font-size: 18px;
    }
    
    .demo-carousel {
        color: #fff;
        font-size: 20px;
        height: 200px;
    }
    
    .ivu-progress-bg {
        background-color: #F5A623 !important;
    }
    
    .height80 {
        height: 80px;
    }
    
    .moreComment {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        cursor: pointer;
        padding-top: 20px;
    }
    
    .moreComment > span {
        z-index: 2;
        position: relative;
        top: 5px;
        color: #4D91E2;
    }
    
    .moreComment:before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        z-index: 1;
        left: 0;
        box-shadow: inset 0 -15px 30px #fff;
    }
    
    .body .ivu-menu-horizontal {
        height: 38px;
        line-height: 38px;
    }
    .indexModal .ivu-modal {
        margin: 10px 30px;
    }
</style>